import { getApiBase } from '@/lib/apiBase';
import {
  clearFlowStorage,
  getFlowOverride,
  getSessionId,
  getSessionToken,
} from '@/lib/flowStorage';

/**
 * Standardized logout behavior for this app:
 * - direct flow => request server-side token revoke
 * - school flow => client logout only (keep parent links working) unless forced
 */
export async function logoutSession(opts = {}) {
  const apiBase = String(opts.apiBase || getApiBase() || '').trim();
  const flowRaw = String(opts.flow || getFlowOverride() || '').trim().toLowerCase();
  const flow = flowRaw === 'school' ? 'school' : 'direct';
  const sessionId = String(opts.sessionId || getSessionId() || '').trim();
  const sessionToken = String(opts.sessionToken || getSessionToken() || '').trim();
  const revokeServerToken =
    typeof opts.revokeServerToken === 'boolean' ? opts.revokeServerToken : flow !== 'school';

  let apiOk = false;
  if (apiBase && sessionId && sessionToken) {
    try {
      const res = await fetch(`${apiBase}/api/users/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Session-Token': sessionToken,
        },
        body: JSON.stringify({
          sessionId,
          sessionToken,
          revokeServerToken,
        }),
      });
      apiOk = res.ok;
    } catch {
      /* non-fatal: still clear local browser state */
    }
  }

  clearFlowStorage();
  return { flow, revokeServerToken, apiOk };
}
